import { SIZES, Typography } from '@fupa/fupa-uikit';
import { AwayGoal, HomeGoal, MatchScore, MatchScoreContainer } from 'app/components/match/matchDetailHeader/MatchDetailHeaderStyles';
import React from 'react';
import { formatDate, formatDayMonthDate, formatTime } from 'app/helpers/dateHelpers';
import MatchLiveMinute from 'app/components/match/matchDetailHeader/MatchLiveMinute';
import styled from 'styled-components';
import MatchStatusDisplay from 'app/components/match/matchDetailHeader/MatchStatusDisplay';
const MatchScoreInformation = styled('div').withConfig({
  componentId: "sc-1jg1dcw-0"
})(["min-height:", ";display:flex;flex-direction:column;justify-content:flex-end;align-items:center;text-align:center;max-width:6.25rem;"], SIZES['24']);
const MatchFlags = {
  Cancelled: 'cancelled',
  Aborted: 'aborted',
  Verdict: 'verdict',
  Penalty: 'penalty',
  Overtime: 'overtime',
  Ticker: 'ticker',
  SoftTicker: 'softticker'
};
const getSofttickerName = reporter => {
  var _ref, _reporter$firstName;
  return (_ref = (_reporter$firstName = reporter === null || reporter === void 0 ? void 0 : reporter.firstName) !== null && _reporter$firstName !== void 0 ? _reporter$firstName : reporter === null || reporter === void 0 ? void 0 : reporter.name) !== null && _ref !== void 0 ? _ref : 'Unbekannt';
};
const getMatchInformation = match => {
  var _match$flags, _match$flags2;
  if ((_match$flags = match.flags) !== null && _match$flags !== void 0 && _match$flags.includes(MatchFlags.SoftTicker) && match.live) {
    const additionalMinute = match.live.additionalMinute ? " +".concat(match.live.additionalMinute) : '';
    return /*#__PURE__*/React.createElement(MatchScoreInformation, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption1"
    }, "".concat(match.live.minute, "'").concat(additionalMinute)), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption1"
    }, "gemeldet von ", getSofttickerName(match.lastSofttickerReporter)));
  }
  const labelByFlag = {
    [MatchFlags.Verdict]: match.verdict || 'Urteil',
    [MatchFlags.Penalty]: 'n.E.',
    [MatchFlags.Overtime]: 'n.V.'
  };
  const foundFlag = (_match$flags2 = match.flags) === null || _match$flags2 === void 0 ? void 0 : _match$flags2.find(flag => labelByFlag[flag]);
  if (!foundFlag) return null;
  return /*#__PURE__*/React.createElement(MatchScoreInformation, {
    "data-sentry-element": "MatchScoreInformation",
    "data-sentry-component": "getMatchInformation",
    "data-sentry-source-file": "MatchHeaderScore.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption1",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "MatchHeaderScore.tsx"
  }, labelByFlag[foundFlag]));
};
const SIX_DAYS_IN_MS = 518400000;
const formatKickoff = kickoff => {
  const curDate = new Date();
  const kickoffDate = new Date(kickoff);
  const isToday = curDate.getFullYear() === kickoffDate.getFullYear() && curDate.getMonth() === kickoffDate.getMonth() && curDate.getDate() === kickoffDate.getDate();
  const isInNext5Days = kickoffDate.getTime() - curDate.getTime() < SIX_DAYS_IN_MS;
  if (isToday) {
    return formatTime(kickoff);
  } else if (isInNext5Days) {
    // Spiel ist in den nächsten 5 Tagen (Wenn heute Mittwoch -> Spiel am Montag)
    return formatDate(kickoff, 'E, HH:mm');
  } else {
    return formatDayMonthDate(kickoff);
  }
};
export default function MatchHeaderScore(_ref2) {
  var _match$flags3, _match$flags4, _match$flags5;
  let {
    match
  } = _ref2;
  const hasFinalScore = typeof match.homeGoal === 'number' && typeof match.awayGoal === 'number';
  if ((_match$flags3 = match.flags) !== null && _match$flags3 !== void 0 && _match$flags3.includes(MatchFlags.Cancelled)) {
    return /*#__PURE__*/React.createElement(MatchScoreContainer, null, /*#__PURE__*/React.createElement(MatchStatusDisplay, {
      text: "abgesagt"
    }));
  }
  if ((_match$flags4 = match.flags) !== null && _match$flags4 !== void 0 && _match$flags4.includes(MatchFlags.Aborted)) {
    return /*#__PURE__*/React.createElement(MatchScoreContainer, null, /*#__PURE__*/React.createElement(MatchStatusDisplay, {
      text: "abgebrochen"
    }));
  }
  const resultInformation = getMatchInformation(match);
  if (match.section === 'LIVE' && (_match$flags5 = match.flags) !== null && _match$flags5 !== void 0 && _match$flags5.includes(MatchFlags.Ticker) && match.live) {
    return /*#__PURE__*/React.createElement(MatchLiveMinute, {
      live: match.live,
      awayGoal: match === null || match === void 0 ? void 0 : match.awayGoal,
      homeGoal: match === null || match === void 0 ? void 0 : match.homeGoal
    });
  }
  if (match.section === 'PRE' && !hasFinalScore) {
    var _match$flags6;
    const hasLiveticker = (_match$flags6 = match.flags) === null || _match$flags6 === void 0 ? void 0 : _match$flags6.includes('ticker');
    const kickoff = formatKickoff(match.kickoff);
    return /*#__PURE__*/React.createElement(MatchScoreContainer, null, /*#__PURE__*/React.createElement(MatchStatusDisplay, {
      text: kickoff
    }), hasLiveticker ? /*#__PURE__*/React.createElement(MatchScoreInformation, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption1"
    }, "live")) : null);
  }
  return /*#__PURE__*/React.createElement(MatchScoreContainer, {
    "data-sentry-element": "MatchScoreContainer",
    "data-sentry-component": "MatchHeaderScore",
    "data-sentry-source-file": "MatchHeaderScore.tsx"
  }, /*#__PURE__*/React.createElement(MatchScore, {
    "data-sentry-element": "MatchScore",
    "data-sentry-source-file": "MatchHeaderScore.tsx"
  }, /*#__PURE__*/React.createElement(HomeGoal, {
    "data-sentry-element": "HomeGoal",
    "data-sentry-source-file": "MatchHeaderScore.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "display2",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "MatchHeaderScore.tsx"
  }, hasFinalScore ? match.homeGoal : '–')), /*#__PURE__*/React.createElement(Typography, {
    variant: "display2",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "MatchHeaderScore.tsx"
  }, ":"), /*#__PURE__*/React.createElement(AwayGoal, {
    "data-sentry-element": "AwayGoal",
    "data-sentry-source-file": "MatchHeaderScore.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "display2",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "MatchHeaderScore.tsx"
  }, hasFinalScore ? match.awayGoal : '–'))), resultInformation);
}